import {createI18nScope} from './scope';

const __i18nScope = createI18nScope(`common.i18n`, {
  'time.less-than-minute-future': `in less than a minute`,
  'time.less-than-minute-past': `less than a minute ago`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.i18n"), "fr": () => import("virtual:i18n-scope/fr/common.i18n"), "id": () => import("virtual:i18n-scope/id/common.i18n"), "ja": () => import("virtual:i18n-scope/ja/common.i18n"), "ko": () => import("virtual:i18n-scope/ko/common.i18n"), "pt": () => import("virtual:i18n-scope/pt/common.i18n"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.i18n"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.i18n")});
export default __i18nScope;
